import * as pdfjsLib from 'pdfjs-dist';

/**
 * Configure PDF.js worker for the application
 * This should be called once when the application starts
 *
 * Uses local worker file from public directory for reliability
 * The worker file is automatically copied from node_modules during postinstall
 * Version: 5.4.149 (must match pdfjs-dist version in package.json)
 */
export function configurePdfWorker(): void {
  // Use local worker file served from public directory
  // This avoids CDN dependency and path resolution issues
  pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
}
